import { render, staticRenderFns } from "./CustomColorPicker.vue?vue&type=template&id=aef09f2a"
import script from "./CustomColorPicker.vue?vue&type=script&lang=js"
export * from "./CustomColorPicker.vue?vue&type=script&lang=js"
import style0 from "./CustomColorPicker.vue?vue&type=style&index=0&id=aef09f2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports